import { _get_user_from_localStorage } from "src/DAL/localStorage/localStorage";

/**
 * Journey guests: people who joined a public journey and opened the portal
 * through an emailed magic link. They only get Dashboard + Journeys.
 */
export const isGuestMember = (userInfo) => {
  if (userInfo && typeof userInfo === "object" && "is_guest" in userInfo) {
    return userInfo.is_guest === true;
  }
  return _get_user_from_localStorage()?.is_guest === true;
};

export const GUEST_HOME_PATH = "/dashboard";

const GUEST_SIDEBAR_PATHS = ["/dashboard", "/trackers"];

/** Routes a guest may open inside the dashboard layout. */
export const isGuestAllowedPath = (pathname = "") => {
  const path = String(pathname || "").replace(/\/+$/, "") || "/";
  return (
    path === "/dashboard" || path === "/trackers" || path.startsWith("/trackers/")
  );
};

export const filterGuestSidebar = (menus = []) =>
  menus.filter((item) => GUEST_SIDEBAR_PATHS.includes(item.path));
